// extracted by mini-css-extract-plugin
export default {"grid":"StatCardGrid_grid__2ov3b"};